(function () {
    'use strict';

    class AccountSetupWaitingController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $translate) {
            super($scope, $injector);
            this.__objectType = 'AccountSetupWaitingController';
            this.subtitle = $translate.instant('COMPANY_SETTING.SETUP._SUBTITLE_DONE_SCREEN_');
            this.btnDoneText = $translate.instant('COMPANY_SETTING.SETUP._BUTTON_DONE_SCREEN_');
        }

        close() {
            this.btnClick();
        }
    }

    Components.AccountSetupWaiting = {
        bindings: {
            title: '=',
            text: '=',
            btnClick: '&'
        },
        controller: AccountSetupWaitingController,
        name : 'hbAccountSetupWaiting',
        templateUrl: 'angular/app/modules/core/features/account_setup/account_setup_waiting_template.html',
    };

}());